import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IGroup } from "@grassrootly/api";

export interface GroupState {
  group: IGroup | null;
}

const initialState: GroupState = {
  group: null,
};

const editGroupSlice = initReducer({
  name: "edit_group",
  initialState,
  reducers: {
    setEditGroup: (state: GroupState, action: PayloadAction<IGroup | null>) => {
      state.group = action.payload;
    },
  },
});

const persistConfig: PersistConfig<GroupState> = {
  key: "edit_group",
  storage: AsyncStorage,
};

export const editGroupActions = editGroupSlice.actions;

export default createPersistReducer(persistConfig, editGroupSlice.reducer);
